import { getUser } from "$lib/userstorage/usersotrage"
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"
import { queryClient, cacheRestored } from "$lib/query/queryClient"
import { queryKeys } from "$lib/query/keys"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD == "si";
let RUTA_JAVA = bd_local ? ruta_local_java : ruta_java;
const RUTA_SERVICIOS = "services"
export function tipoServicios() {
    return [
        { id: "INSEMINATION", nombre: "Inseminación artificial" },
        { id: "NATURAL_SERVICE", nombre: "Servicio natural" },
    ]
}
// Resumen de las madres de un servicio en lote: hasta 4 muestra las caravanas
// (tags); más de 4 colapsa a "N animales" (evita una fila/línea ilegible).
// `colapsado` le dice al caller si debe renderizar chips (tags) o el texto.
const RESUMEN_MAX_TAGS = 4;
export function resumenAnimales(tagNumbers) {
    const tags = tagNumbers ?? [];
    if (tags.length > RESUMEN_MAX_TAGS) {
        return { colapsado: true, tags: [], texto: `${tags.length} animales` };
    }
    return { colapsado: false, tags, texto: tags.join(", ") };
}
function processServicio(fila) {
    let padres = []
    let pajuelas = []
    if (fila.fathers.length > 0) {
        for (let i = 0; i < fila.fathers.length; i++) {
            let padre = fila.fathers[i]

            padres.push(padre.fatherId)

            pajuelas.push(padre.fatherTagNumber)
        }
    }
    else {
        pajuelas = [fila.strawCode]
    }

    const animalIds = fila.animalIds && fila.animalIds.length > 0
        ? fila.animalIds
        : (fila.animalId ? [fila.animalId] : []);
    const animalTagNumbers = fila.animalTagNumbers && fila.animalTagNumbers.length > 0
        ? fila.animalTagNumbers
        : (fila.animalTagNumber ? [fila.animalTagNumber] : []);
    const caravanaDisplay = resumenAnimales(animalTagNumbers).texto;

    let data_ser = {

        id: fila.serviceId,
        fechadesde: fila.startDate,
        fechainseminacion: fila.startDate,
        fechahasta: fila.endDate,
        madre: fila.animalId,
        animal: fila.animalId,
        animalIds,
        animalTagNumbers,
        // Detalle por madre (padre(s) + pajuela + observación particular),
        // fuente de verdad para el desplegable de la lista — sin esto, el
        // desplegable solo tenía las caravanas (perdía el padre/observación
        // de cada madre que sí viaja en el DTO).
        animalDetails: fila.animalDetails ?? [],
        pajuelas: pajuelas.join(),
        padres: padres.length > 0 ? padres.join() : "",

        padre: padres.length > 0 ? padres.join() : "",
        observacion: fila.notes,
        fechaparto: fila.expectedBirthDate,
        active: fila.isActive,
        cab: fila.establishmentId,
        tipo: fila.serviceType,
        created: fila.creationDate,
        updated: fila.updateDate,
        expand: {
            madre: {
                id: fila.animalId,
                caravana: caravanaDisplay
            },
            animal: {
                id: fila.animalId,
                caravana: caravanaDisplay
            }
        }
    }
    return data_ser
}
export function processServicios(data) {
    let servicios = []
    for (let i = 0; i < data.length; i++) {
        let fila = data[i]
        servicios.push(processServicio(fila))
    }
    return servicios
}
// Trae el ServiceDto crudo (sin el aplanado de processServicio, que colapsa
// el detalle por madre a strings joineados) — lo necesita la pantalla de
// edición para poder editar el padre/pajuela/observación de cada madre
// (animalDetails), no solo el valor general del servicio.
export async function getServicio(id) {
    let user = getUser();
    let token = user.token;
    let ruta = `${RUTA_JAVA}${RUTA_SERVICIOS}/${id}`
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res = await handleAuthenticatedRequest(ruta, options)
    return await jsonOrThrow(res, "servicios.getServicio")
}
function isRealError(err) {
    return !!err && (err.message === "SESIÓN_EXPIRADA" || err.message === "SIN_PERMISO" || typeof err.status === "number")
}
export async function getAllServices(cabid = null) {
    let user = getUser();
    let token = user.token;
    let ruta_all = `${RUTA_JAVA}${RUTA_SERVICIOS}/all`
    let url = new URL(ruta_all)
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res_all = await handleAuthenticatedRequest(url.toString(), options)

        let data_all = await jsonOrThrow(res_all, "servicios.getAllServices")

        return processServicios(data_all)
    } catch (err) {
        if (isRealError(err)) throw err
        await cacheRestored
        const cached = cabid ? queryClient.getQueryData(queryKeys.services(cabid)) : null
        if (Array.isArray(cached)) return cached
        throw err
    }
}
export function postServicio(data) {
    let data_java = {
        animalId: data.madre,
        establishmentId: data.cab,
        serviceType: data.tipo,
        startDate: data.fechadesde.split(" ")[0],
        endDate: data.fechahasta && data.fechahasta.length > 0 ? data.fechahasta.split(" ")[0] : "",
        strawCode: data.pajuela,
        // Filtrar ids vacíos: "".split(",") → [""] generaría un padre fantasma
        // {fatherId: 0} que el backend rechaza con "Animal not found".
        fathers: (data.padres ?? "").split(",")
            .map(item => item.trim())
            .filter(item => item !== "")
            .map(item => ({
                fatherId: Number(item),
                fatherTagNumber: "", notes: ""
            })),
        expectedBirthDate: data.fechaparto.split(" ")[0],
        notes: data.observacion
    }

    return data_java;

}
export function postInseminacion(data) {
    let data_java = {
        animalId: data.animal,
        establishmentId: data.cab,
        serviceType: data.tipo,
        startDate: data.fechainseminacion.split(" ")[0],
        endDate: "",
        strawCode: data.pajuela,
        fathers: data.padre.length>0?[{fatherId:data.padre,fatherTagNumber:"",notes:""}]:[],
        expectedBirthDate: data.fechaparto.split(" ")[0],
        notes: data.observacion
    }

    return data_java;
}
export async function saveServicio(data) {
    let ruta = `${RUTA_JAVA}${RUTA_SERVICIOS}`
    let user = getUser();
    let token = user.token;
    //let data_java = postServicio(data)
    let res_post = await fetch(ruta,
        {
            method: "POST",
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    let data_post = await res_post.json()
    return data_post
}
export async function saveServicioBulk(data) {
    let ruta = `${RUTA_JAVA}${RUTA_SERVICIOS}/bulk`
    let user = getUser();
    let token = user.token;
    //let data_java = postServicio(data)
    let res_post = await fetch(ruta,
        {
            method: "POST",
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    let data_post = await res_post.json()
    return data_post
}
export async function editServicio(id, data) {
    let ruta = `${RUTA_JAVA}${RUTA_SERVICIOS}/${id}`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "PUT",
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    let data_post = await res_post.json()
    return data_post
}
export async function eliminarServicio(id) {
    let ruta = `${RUTA_JAVA}${RUTA_SERVICIOS}/delete/${id}`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "POST",
            //            body: JSON.stringify({}), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    //let data_post = await res_post.json()
    return {}
}
